import { render, staticRenderFns } from "./SlotEvents.vue?vue&type=template&id=7313e778&"
import script from "./SlotEvents.vue?vue&type=script&lang=js&"
export * from "./SlotEvents.vue?vue&type=script&lang=js&"
import style0 from "./SlotEvents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports